import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "listing", "campaignQuantity", "bundleListing", "bundleQuantity" ]

  connect() {
    this.syncCampaignQuantities()
    this.bundleListingTargets.forEach((select) => this.syncBundleQuantity(select))
  }

  listingChanged() {
    this.syncCampaignQuantities()
  }

  bundleListingChanged(event) {
    this.syncBundleQuantity(event.currentTarget)
  }

  syncCampaignQuantities() {
    if (!this.hasListingTarget) return

    const quantityRules = this.quantityRulesFor(this.listingTarget)
    this.campaignQuantityTargets.forEach((input) => this.applyQuantityRules(input, quantityRules))
  }

  syncBundleQuantity(select) {
    const row = select.closest(".marketplace-group-buy-repeat-row")
    const input = row?.querySelector('[data-marketplace-group-buy-form-target~="bundleQuantity"]')
    if (!input) return

    this.applyQuantityRules(input, this.quantityRulesFor(select))
  }

  quantityRulesFor(select) {
    const selectedOption = select.selectedOptions[0]

    return {
      minimum: selectedOption?.dataset.quantityMinimum || "1",
      step: selectedOption?.dataset.quantityStep || "1"
    }
  }

  applyQuantityRules(input, quantityRules) {
    input.min = quantityRules.minimum
    input.step = quantityRules.step
  }
}
